/**
 *
 * TODO ฟังก์ชั่นสำหรับ set, get localStorage
 * ครอบ try/catch ทุกฟังก์ชั่น เพราะ localStorage อาจถูกปิดใช้งาน (เช่น block cookies)
 * และค่าที่เก็บอาจไม่ใช่ JSON (เขียนโดย extension หรือแอปเวอร์ชั่นเก่า) ซึ่งทำให้แอปพังทั้งหน้า
 */
export const getStored = (filedName) => {
  try {
    const raw = localStorage.getItem(filedName);
    if (!raw || raw === 'undefined') return '';
    return JSON.parse(raw);
  } catch (error) {
    // ค่าที่ parse ไม่ได้ถือว่าเสีย ลบทิ้งเพื่อไม่ให้พังซ้ำในครั้งถัดไป
    try {
      localStorage.removeItem(filedName);
    } catch (removeError) {
      // localStorage ถูกปิดใช้งาน ไม่ต้องทำอะไรต่อ
    }
    return '';
  }
};

export const setStored = (filedName, value) => {
  try {
    return localStorage.setItem(filedName, JSON.stringify(value));
  } catch (error) {
    return undefined;
  }
};

export const removeStored = (filedName) => {
  try {
    return localStorage.removeItem(filedName);
  } catch (error) {
    return undefined;
  }
};

export const clearStored = () => {
  try {
    return localStorage.clear();
  } catch (error) {
    return undefined;
  }
};
